var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3937 11438)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    transform: "translate(3937 -11438)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3938 -11438)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M79.581,80.238A.818.818,0,1,0,78.423,81.4l2.421,2.422H70.82a.818.818,0,0,0,0,1.636H80.845l-2.421,2.421a.818.818,0,0,0,1.157,1.157L83.4,85.214a.818.818,0,0,0,0-1.157Z",
    transform: "translate(-66.729 -75.635)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.909,18a.818.818,0,1,0,0-1.636H11.636V1.636h6.273a.818.818,0,1,0,0-1.636H10.818A.818.818,0,0,0,10,.818V17.182a.818.818,0,0,0,.818.818Z",
    transform: "translate(-10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/signOut.4d426453c7bbdf259755fbd88e5340c3.svg";
export { ForwardRef as ReactComponent };